import { render } from "./SearchCases.vue?vue&type=template&id=36e68a20"
import script from "./SearchCases.vue?vue&type=script&lang=js"
export * from "./SearchCases.vue?vue&type=script&lang=js"

import "./SearchCases.vue?vue&type=style&index=0&id=36e68a20&lang=sass"

import exportComponent from "/home/ploi/orthomatrix.orthosol.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__